import { Grid } from "@mui/material";
import React from "react";
import "./profile.css";
import CollectionGrid from "../Home_Page/CollectionGrid";

function Profile() {
  const profileOne = [
    {
      num: "105",
      numText: "Collections",
    },
    {
      num: "406",
      numText: "creations",
    },
  ];
  const profileTwo = [
    {
      iconSrc: "./Assets/FacebookLogo.png",
      iconText: "facebook",
    },
    {
      iconSrc: "./Assets/messengerLogo.png",
      iconText: "messenger",
    },
    {
      iconSrc: "./Assets/WhatsappLogo.png",
      iconText: "WhatsApp",
    },
    {
      iconSrc: "./Assets/YoutubeLogo.png",
      iconText: "Youtube",
    },
  ];

  const profileThree = [
    {
      follow: "follow",
      plusIcon: "./Assets/Plus.png",
    },
    {
      follow: "share",
      plusIcon: "./Assets/LineSegments.png",
    },
    {
      follow: "report",
      plusIcon: "./Assets/Flag.png",
    },
  ];
  const btnStyles = [
    {
      btnDes: " All Items",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Music",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Games",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Art",
      btnClass: "common_btn",
    },
    {
      btnDes: " photography",
      btnClass: "hero_btn",
    },
  ];
  return (
    <div className="profile_main">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={11} lg={10}>
          <div className="profile_cover">
            <img src="./Assets/cover_img.png" className="cover_img" alt="" />
            <img
              src="./Assets/profile_picture.png"
              alt=""
              className="profile_picture"
            />
            <div className="profile_head">
              <span className="name">Youb fennouni</span>
              <span className="since">Since 2021</span>
            </div>
          </div>
          <Grid
            container
            sx={{
              justifyContent: {
                xs: "center",
                sm: "center",
                md: "space-between",
                lg: "space-between",
              },
            }}
            alignItems="flex-start"
          >
            <Grid item xs={11} md={5} lg={5}>
              <div className="profile_des">
                <p className="profile_about">
                  I make art with the simple goal of giving you something
                  pleasing to look at for a few seconds.
                </p>
              </div>
              <div className="profile_details">
                {profileOne.map((e) => {
                  return (
                    <div className="collection_num">
                      <h3 className="num">{e.num}</h3>
                      <span className="num_text">{e.numText}</span>
                    </div>
                  );
                })}
              </div>
              <div className="seprator_profile"></div>
            </Grid>

            <Grid item xs={11} sm={11} md={5} lg={5}>
              <div className="profile_card">
                <Grid
                  container
                  alignItems="center"
                  sx={{
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      lg: "space-between",
                    },
                  }}
                >
                  <Grid item xs={12} sm={6} md={5} lg={5}>
                    <h2 className="follow_me">follow me</h2>

                    {profileTwo.map((e) => {
                      return (
                        <div className="sm_icon">
                          <div className="span_icon">
                            <span>
                              <img
                                src={e.iconSrc}
                                alt=""
                                className="social_icon"
                              />
                            </span>
                            <span className="icon_des">{e.iconText}</span>
                          </div>
                        </div>
                      );
                    })}
                  </Grid>
                  <Grid item xs={12} sm={6} md={5} lg={5}>
                    {profileThree.map((e) => {
                      return (
                        <>
                          <button className="social_btn">
                            {e.follow}
                            <span className="span_social">
                              <img
                                src={e.plusIcon}
                                alt=""
                                className="plus_icon"
                              />
                            </span>
                          </button>
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: {
                xs: "center",
                sm: "center",
                md: "center",
                lg: "space-between",
              },
            }}
          >
            <Grid item xs={10} md={5} lg={5}>
              <div className="profile_collection">
                <h1 className="head_h_profile">collection</h1>
                <h1 className="head_h_profile_t">creation</h1>
              </div>
            </Grid>

            <Grid item xs={12} md={9} lg={7}>
              <ul className="btn_gal">
                {btnStyles.map((e) => {
                  return (
                    <li className="btn_items">
                      <button className={e.btnClass}>{e.btnDes}</button>
                    </li>
                  );
                })}
              </ul>
            </Grid>
          </Grid>
          <div className="seprator"></div>

          <Grid container justifyContent="center">
            <Grid item xs={12} md={8} lg={12}>
              <CollectionGrid />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className="seprator"></div>
    </div>
  );
}

export default Profile;
